module.exports = __webpack_public_path__ + "img/img9.d41f83c5.svg";